/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('.selector-address-province-default').on('change',(event) => {
    getCityList(event.target.value,'default');
    let citySelect =  $('.selector-address-city-default').find(":selected").val();
    $('.input-address-city-default--hidden').val(citySelect);
});
$('.selector-address-province-new').on('change',(event) => {
    getCityList(event.target.value,'new'); 
    let idAddress = event.target.id.replace('address-','').replace('[province]','');
    let citySelect =  $('#address-'+idAddress+'-city--select').find(":selected").val();
    $('.input-address-city-new--hidden').val(citySelect);
});
$('.selector-address-province').on('change',(event) => {
    let idAddress = event.target.id.replace('address-','').replace('[province]','');
    getCityListEdit(event.target.value, idAddress);
    let citySelect =  $('#address-'+idAddress+'-city--select').find(":selected").val();
    document.getElementById('address-'+idAddress+'[city]').value = citySelect;
    
});
 $('.selector-address-city-default').on('change',(event) => {
     $('.input-address-city-default--hidden').val(event.target.value);
 });
 $('.selector-address-city-new').on('change',(event) => {
    $('.input-address-city-new--hidden').val(event.target.value);
});
$('.selector-address-city-edit').on('change',(event) => {
    let idAddress = event.target.id.replace('address-','').replace('-city--select','');
    
    document.getElementById('address-'+idAddress+'[city]').value = event.target.value;
    
});
 function getCityList(name,type) {
    $('.selector-address-city-'+type).html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    $(allCities).map((node, item) => { 
        if(name.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('.selector-address-city-'+type).append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
            });
        }

    });
 }
 function getCityListEdit(name, id) {
    console.log(name, id);
    $('#address-'+id+'-city--select').html('<option disabled="disabled" value="---" data-provinces="[]">---</option>');
    $(allCities).map((node, item) => { 
        if(name.toLowerCase() == item.Departamento.toLowerCase()){
            item.Municipio.map((city) => { 
                $('#address-'+id+'-city--select').append('<option value="'+city+'" data-provinces="[]">'+city+'</option>')
            });
        }

    });
 }
 function getProvinceList() {
    $('.selector-address-province option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });
    $('.selector-address-province-default option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province-default option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });
    $('.selector-address-province-new option').each(function() {
        allCities.map((item) => { 
        if ( $(this).val() == item.Departamento ) {
            $(this).addClass('city-enable');
        }
    });
    });
    $('.selector-address-province-new option').each(function() {
        if(!$(this).hasClass("city-enable")){
            $(this).remove();
        }
    });

    let provinceName = $('.selector-address-province-default').find(":selected").val();
    let idAddress = $('.selector-address-province-default').attr('id').replace('address-','').replace('[province]','');

    getCityList(provinceName,'default');

    getCityList(allCities[0].Departamento,'new');
    $('.input-address-city-new--hidden').val(allCities[0].Municipio[0]);

    let inputCity = $('.input-address-city-default--hidden').val();
    console.log(inputCity);
    $('.selector-address-city-default option:contains('+inputCity+')').attr('selected', 'selected');

    $('.selector-address-province').each(function() {
        let idAddress = $(this).attr('id').replace('address-','').replace('[province]','');
        inputCity = document.getElementById('address-'+idAddress+'[city]').getAttribute("value");
        let inputProvince = document.getElementById('address-'+idAddress+'[province]').getAttribute("data-default");
        if(inputProvince == "Bogotá, D.C."){
            inputProvince = "Bogotá";
            $(this).find('option:contains('+inputProvince+')').attr('selected', 'selected');
        }
        provinceName = $(this).find('option:selected').val();
        getCityListEdit(provinceName, idAddress);
        console.log(inputCity, idAddress);
        $('#address-'+idAddress+'-city--select option:contains('+inputCity+')').attr('selected', 'selected');
        
    });
 }
 getProvinceList();